import { BaseStore } from "stores/base_store"
import { runInAction, makeAutoObservable } from "mobx"
import { api_get, api_post } from "api/utils"
import { CursorType } from "utils/types"
export type TeamInviteType = {
    key: string;
    uuid: string;
    identity: string;
    team: string;
    email: string;
    accepted: boolean;
    date_accepted: string;
    accepted_identity: string;

    date_created: string;
    date_updated: string;
    updateProps?: (attributes: TeamInviteType) => void;
};

// Domain object TeamInvite
export class TeamInvite implements TeamInviteType {
    key = "";
    uuid = "";
    identity = "";
    team = "";
    email = "";
    accepted = false;
    date_accepted = "";
    accepted_identity = "";

    date_created = "";
    date_updated = "";

    constructor(attributes: TeamInviteType) {
        makeAutoObservable(this, {
            updateProps: false
        })
        if (attributes) {
            this.updateProps(attributes);
        }
    }

    updateProps(attributes: TeamInviteType) {
        runInAction(() => {
            Object.assign(this, attributes);
        });
    }
}


export class TeamInviteStore extends BaseStore<TeamInviteType, TeamInvite> {


    async fetchTeamInvite(uuid: string) {
        const response = await api_get(`/team-invite/?uuid=${uuid}`);
        if(response.ok) {
            const data = await response.json();
            this.receiveUpdate(data);
            return data;
        }
        return null;
    }


    async createByEmail(identity: string, team: string, email: string, message: string) {
        const response = await api_post('/team-invite/create/by-email', { identity, team, email, message });
        if(response.ok) {
            const data = await response.json();
            this.receiveUpdate(data);
            return data;
        }
        return null;
    }

    async fetchList(identity: string, cursor?: CursorType): Promise<TeamInviteType[]>  {
        // Autogenerated
        const url = "/team-invite/list";
        const params = {
            identity,
            cursor: cursor || ''
        };
        const response = await api_get(url, params);
        if (response.ok) {
            const data = await response.json();
            this.receiveUpdate(data.items);
            if(data?.cursor) {
                this.fetchList(identity, data.cursor);
            }
            // This returns as possibly incomplete list due to the cursor,
            // but TeamInviteStore.items is complete when .then() is called
            // so you can/should just use that.
            return data.items;
        }
        return [];
    };

    async acceptInvite(
            invite: string,
        email: string,
        handle: string
    ) : Promise<TeamInviteType|null> {
        const response = await api_post('/team-invite/accept', { uuid: invite, email, handle });
        if(response.ok) {
            const data = await response.json();
            this.receiveUpdate(data);
            return data;
        }
        const error = await response.json();
        throw error.message;
    }

    modelConstructor() {
        return TeamInvite;
    }

}
